export var CubedStep;
(function (CubedStep) {
    CubedStep.DefaultNote = 60;
    // one int32 per step: midi-note 0..6, active 7, slide 8, accent 9
    CubedStep.pack = (step) => (step.note & 0x7F)
        | ((step.active ? 1 : 0) << 7)
        | ((step.slide ? 1 : 0) << 8)
        | ((step.accent ? 1 : 0) << 9);
    CubedStep.unpack = (bits) => ({
        note: bits & 0x7F,
        active: ((bits >> 7) & 1) === 1,
        slide: ((bits >> 8) & 1) === 1,
        accent: ((bits >> 9) & 1) === 1
    });
})(CubedStep || (CubedStep = {}));
